import { render } from "./Step4PatientInformation.vue?vue&type=template&id=066cee11"
import script from "./Step4PatientInformation.vue?vue&type=script&lang=js"
export * from "./Step4PatientInformation.vue?vue&type=script&lang=js"

import "./Step4PatientInformation.vue?vue&type=style&index=0&id=066cee11&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__